import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { reduxForm, formValueSelector } from 'redux-form';

import { compose } from '../../utils';
import { saving } from '../../redux/form/selectors';
import { list, defaultLang } from '../../redux/lang/selectors';

import CustomForm from './CustomForm';

const values = formValueSelector('customForm');

const reduxConect = connect(
  createStructuredSelector({
    saving,
    langList: list,
    defaultLang,
    documentId: state => values(state, 'documentId'),
  }),
);

const formConect = reduxForm({
  form: 'customForm',
  enableReinitialize: true,
});

export { CustomForm };

export default compose(reduxConect, formConect)(CustomForm);
